import { useQuery } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';

import { TransactionInitiatorDocument } from './transactionInitiator.gql';

const useTransactionInitiator = ({ companyUserId = '' }) => {
  const { companyProfileId } = useCompanyContext();

  if (!companyProfileId) {
    throw new Error(
      'companyProfileId is not defined in useTransactionInitiator',
    );
  }

  const { data, ...hook } = useQuery(TransactionInitiatorDocument, {
    skip: !companyUserId,
    variables: { companyProfileId },
  });

  const users = data?.viewer.company.users || [];

  const initiator = users.find(
    (companyUser) => companyUser.companyUserId === companyUserId,
  );

  return { ...hook, initiator };
};

export default useTransactionInitiator;
